import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/lenisManager";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Performance } from "@/components/site/Performance";
import { About } from "@/components/site/About";
import { Work } from "@/components/site/Work";
import { Pillars } from "@/components/site/Pillars";
import { Services } from "@/components/site/Services";
import { WhyBrands } from "@/components/site/WhyBrands";
import { Brands } from "@/components/site/Brands";
import { InstagramStrip } from "@/components/site/InstagramStrip";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MobileCTA } from "@/components/site/MobileCTA";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const noLenis = window.location.search.includes("nolenis");
    if (prefersReduced || noLenis) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    setLenis(lenis);
    window.__lenis = lenis;

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-cream text-ink">
      <Nav />
      <main>
        <Hero />
        <Performance />
        <About />
        <Work />
        <Pillars />
        <Services />
        <WhyBrands />
        <Brands />
        <InstagramStrip />
        <Contact />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}

export default App;
